import axiosInstance from 'src/utils/axios';
import * as Types from './types.api';

//
//

const EXTEND_URL = '/footprints/v1';
const PROCESSING_URL = '/footprints/v1/asynchronous-processing';

//

export const getMerchantFootprintResultsAPI = async (
  query: Types.GetMerchantFootprintResultsQuery
): Promise<Types.FootprintsResponse> => {
  let params = new URLSearchParams();
  params.set('merchantCode', query.merchantCode);
  if (query.pageSize) params.set('pageSize', query.pageSize.toFixed());
  if (query.pageNumber) params.set('pageNumber', query.pageNumber.toFixed());
  if (query.calculatorMode?.length) {
    query.calculatorMode.forEach(mode => {
      params.append('calculatorMode', mode);
    });
  }
  if (query.sort) params.set('sort', query.sort);
  if (query.order) params.set('order', query.order);
  if (query.programmeCode) params.set('programmeCode', query.programmeCode);

  const response = await axiosInstance.get<Types.FootprintsResponse>(
    `${EXTEND_URL}/business/results?${params.toString()}`
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const getMerchantFootprintResultsAPIv2 = async (
  query: Types.GetMerchantFootprintResultsQuery
): Promise<Types.FootprintsResponseV2> => {
  let params = new URLSearchParams();
  params.set('merchantCode', query.merchantCode);
  if (query.pageSize) params.set('pageSize', query.pageSize.toFixed());
  if (query.pageNumber) params.set('pageNumber', query.pageNumber.toFixed());
  if (query.calculatorMode?.length) {
    query.calculatorMode.forEach(mode => {
      params.append('calculatorMode', mode);
    });
  }
  if (query.sort) params.set('sort', query.sort);
  if (query.order) params.set('order', query.order);
  if (query.programmeCode) params.set('programmeCode', query.programmeCode);

  const response = await axiosInstance.get<Types.FootprintsResponseV2>(
    `${EXTEND_URL}/business/results?${params.toString()}`
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

// not used
export const getUserActionsAPI = async (params: { email: string }) => {
  return axiosInstance.get(`/reduce/v1/user-actions`, {
    params,
    paramsSerializer: { indexes: null },
  });
};

export const getUserActionCountByUserIdsAPI = async (
  carbonUserIds: string[]
): Promise<Types.UserCommittedActionsResponse> => {
  const response = await axiosInstance.get<Types.UserCommittedActionsResponse>(
    `/reduce/v1/user-actions/committed/count`,
    {
      params: { carbonUserIds },
      paramsSerializer: { indexes: null },
    }
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const getUserFootprintByUserIdsAPI = async (
  carbonUserIds: string[]
): Promise<Types.LatestUsersFootprintsResponse> => {
  const response = await axiosInstance.get<Types.LatestUsersFootprintsResponse>(
    `${EXTEND_URL}/personal/latest/users`,
    {
      params: { carbonUserIds },
      paramsSerializer: { indexes: null },
    }
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const getUserCommuteFootprintByUserIdsAPI = async (
  carbonUserIds: string[]
): Promise<Types.LatestUsersCommuteFootprintResponse> => {
  const response = await axiosInstance.get<Types.LatestUsersCommuteFootprintResponse>(
    `${EXTEND_URL}/commute/latest/users`,
    {
      params: { carbonUserIds },
      paramsSerializer: { indexes: null },
    }
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const getMerchantFootprintAPI = async (
  merchantCode: string,
  footprintId: string
): Promise<Types.FootprintResponse> => {
  let params = new URLSearchParams();
  params.set('merchantCode', merchantCode);

  const response = await axiosInstance.get<Types.FootprintResponse>(
    `${EXTEND_URL}/business/results/${footprintId}?${params.toString()}`
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const getMerchantFootprintAPIv2 = async (
  query: Types.FootprintQueryV2
): Promise<Types.FootprintResponseV2> => {
  const { merchantCode, footprintId } = query;

  let params = new URLSearchParams();
  params.set('merchantCode', merchantCode);

  const response = await axiosInstance.get<Types.FootprintResponseV2>(
    `${EXTEND_URL}/business/results/${footprintId}?${params.toString()}`
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

//

export const deleteMerchantFootprintAPI = async (footprintId: string) => {
  return axiosInstance.delete(`${EXTEND_URL}/business/${footprintId}`);
};

// not used
export const getUserFootprintAPI = async (params: { email: string }) => {
  return axiosInstance.get(`${EXTEND_URL}/personal/latest`, {
    params,
    paramsSerializer: { indexes: null },
  });
};

export const getUserActionStatsAPI = async (
  params: Types.GetUserActionStatsQuery
): Promise<Types.UserActionStatsResponse> => {
  const response = await axiosInstance.get<Types.UserActionStatsResponse>(
    `/reduce/v1/user-actions/stats`,
    {
      params,
      paramsSerializer: { indexes: null },
    }
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

//
export const saveMerchantFootprintAPI = async (
  merchantCode: string,
  data: Types.SaveMerchantFootprintPayload,
  programmeCode?: string
): Promise<Types.FootprintResponse> => {
  const response = await axiosInstance.post<Types.FootprintResponse>(
    `${EXTEND_URL}/business?merchantCode=${merchantCode}${programmeCode ? `&programmeCode=${programmeCode}` : ''}`,
    JSON.stringify(data)
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const saveMerchantFootprintAPIv2 = async (
  merchantCode: string,
  data: Types.SaveMerchantFootprintPayloadV2,
  programmeCode?: string
): Promise<Types.FootprintResponseV2> => {
  const response = await axiosInstance.post<Types.FootprintResponseV2>(
    `${EXTEND_URL}/business?merchantCode=${merchantCode}${programmeCode ? `&programmeCode=${programmeCode}` : ''}`,
    JSON.stringify(data)
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

//
export const saveMerchantFootprintResultAPI = async (merchantCode: string, data: any) => {
  return axiosInstance.post(
    `${EXTEND_URL}/business/results?merchantCode=${merchantCode}`,
    JSON.stringify(data)
  );
};

export const updateMerchantFootprintAPI = (payload: Types.UpdateMerchantFootprintPayload) => {
  const { footprintId, merchantCode, data } = payload;

  return axiosInstance.put(
    `${EXTEND_URL}/business/${footprintId}?merchantCode=${merchantCode}`,
    JSON.stringify(data)
  );
};

export const updateMerchantFootprintResultsAPI = (
  footprintId: string,
  merchantCode: string,
  data: any
) => {
  return axiosInstance.put(
    `${EXTEND_URL}/business/results/${footprintId}?merchantCode=${merchantCode}`,
    JSON.stringify(data)
  );
};

export const getFootprintCalculationAPI = async (
  params: Types.GetFootprintCalculationParams
): Promise<Types.FootprintCalculationResponse> => {
  const { merchantCode, ...data } = params;

  const response = await axiosInstance.get<Types.FootprintCalculationResponse>(
    `${EXTEND_URL}/personal/merchant-programmes/${merchantCode}`,
    {
      params: data,
      paramsSerializer: { indexes: null },
    }
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const getMerchantFootprintResultsSummaryAPI = (
  p: Types.GetFootprintResultsSummaryParams
) => {
  let params = new URLSearchParams();
  params.set('merchantCode', p.merchantCode);
  if (p.calculatorMode) params.set('calculatorMode', p.calculatorMode);
  return axiosInstance.get(`${EXTEND_URL}/business/results/summary?${params.toString()}`);
};

//

export const uploadFlightEmissionsFileAPI = async (
  merchantCode: string,
  file: File,
  activityName: string,
  emailAddress: string,
  ignoreCalculations: boolean = false
) => {
  const formData = new FormData();
  formData.append('file', file);
  const config = {
    headers: { 'Content-Type': 'multipart/form-data' },
  };

  return axiosInstance.post(
    `${EXTEND_URL}/flights?merchantCode=${merchantCode}&activityName=${activityName}&emailAddress=${emailAddress}&ignoreCalculations=${ignoreCalculations}`,
    formData,
    config
  );
};

export const uploadBulkEmissionsFileAPI = async (
  merchantCode: string,
  file: File,
  emailAddress: string,
  activityName: string = 'bulk emissions',
  ignoreCalculations: boolean = false
) => {
  const formData = new FormData();
  formData.append('file', file);
  const config = {
    headers: { 'Content-Type': 'multipart/form-data' },
    params: { merchantCode, activityName, emailAddress, ignoreCalculations },
  };

  return axiosInstance.post(`${EXTEND_URL}/bulkEmissionsFile`, formData, config);
};

//
//

export const uploadFootprintFlightsFileAPI = async (
  payload: Types.UploadFootprintFlightsFileStatusPayload
): Promise<Types.UploadFlightsFileResponse> => {
  const { file, ...params } = payload;

  const formData = new FormData();
  formData.append('file', file);

  const response = await axiosInstance.post(PROCESSING_URL, formData, {
    params,
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const getFileUploadStatusAPI = async (
id: string
): Promise<Types.UploadFlightsFileResponse> => {
  const response = await axiosInstance.get(`${PROCESSING_URL}/${id}`);

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const dismissFootprintFlightsFileAPI = async (id: string) => {
  const response = await axiosInstance.post(`${PROCESSING_URL}/${id}/dismiss`);

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};
